export default {
  name: 'changsha',
  adcode: '430100',
  mapName: '长沙市',
  geoJsonPath: 'hunanmap/430100.json',
  backgroundImage: {
    png: '长沙市_430100.png',
    webp: '长沙市_430100.webp'
  },
  echartsMapStyle: {
    width: '944px',
    height: '685px',
    marginTop: 'auto',
    marginBottom: '55px',
  },
  imageSize: {
    width: 4356,
    height: 3160
  },
  // 地图特殊配置：背景图片适配参数
  specialConfig: {
    // 独立调整参数
    layoutSizeAdjustment: {
      enabled: true,
      multiplier: 1.36, // 布局尺寸调整倍数（微调）
      minSize: 400,     // 最小布局尺寸
      maxSize: 1200     // 最大布局尺寸
    },
    aspectScaleAdjustment: {
      enabled: true,
      multiplier: 0.99, // 宽高比调整倍数（微调）
      minScale: 0.5,    // 最小缩放比例
      maxScale: 2.0     // 最大缩放比例
    },
    // 位置偏移补偿
    positionOffset: {
      x: 0.001,  // X轴偏移百分比
      y: 0.001  // Y轴偏移百分比
    }
  },
  // 区县列表
  districts: ['长沙市区', '望城区', '长沙县', '宁乡市', '浏阳市'],
  // 区县坐标映射（用于tooltip定位与涟漪效果）
  cityCoords: {
    '长沙市区': [112.9122, 28.1678],
    '长沙市': [112.9892, 28.1127],
    '望城区': [112.6935, 28.3124],
    '长沙县': [113.0814, 28.4978],
    '宁乡市': [112.4141, 27.9782],
    '浏阳市': [113.5534, 28.4782]
  },
  // 区县名称标准化
  normalizeName: (name) => {
    if (!name) return ''
    const s = String(name).trim()
    if (s === '长沙市') return '长沙市区'
    if (s === '宁乡县') return '宁乡市'
    return s
  },
  // 区县与adcode映射
  cityAdcodeMap: {
    '芙蓉区': '430102',
    '天心区': '430103',
    '岳麓区': '430104',
    '开福区': '430105',
    '雨花区': '430111',
    '望城区': '430112',
    '长沙县': '430121',
    '宁乡市': '430181',
    '浏阳市': '430181'
  }
}